import React from 'react';
import { SMS_UNAVAILABLE_TEXT } from '../domain/notifications';
import s from './SmsUnavailable.module.css';

// The one line under a "send a text" control while this deployment cannot
// send one (#782, domain/smsGate.js). The control itself stays where it is,
// disabled and drawn off, with `smsOffClass` on its row — FormControls'
// `rowDisabled` look — so a teacher can see the option exists and why it
// cannot be taken. The line is outside the dimmed row so it reads at full
// contrast.

/** The dimmed look for a gated control's own row. */
export const smsOffClass = s.off;

export default function SmsUnavailable() {
  return <span className={s.note}>{SMS_UNAVAILABLE_TEXT}</span>;
}
